import { render, staticRenderFns } from "./AgreementsNice.vue?vue&type=template&id=44d6b87f&scoped=true&"
import script from "./AgreementsNice.vue?vue&type=script&lang=js&"
export * from "./AgreementsNice.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsNice.vue?vue&type=style&index=0&id=44d6b87f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d6b87f",
  null
  
)

export default component.exports